import { action, computed, observable } from 'mobx'

import { Entity } from 'shared/stores/BaseStore'
import { USER_PERMISSION } from 'shared/types/types'

import { UserPvzRolesDTO } from '../../../types/typesDTO'

export class EmployeeRole extends Entity {
  @observable externalId = 0
  @observable officeName = ''
  @observable role = USER_PERMISSION.PERM_NONE
  @observable district = ''

  @observable cachedRole = USER_PERMISSION.PERM_NONE
  @observable roleWasChangedInModal = false

  constructor(
    props: Omit<
      EmployeeRole,
      /* Здесь перечислены свойства, которых нет в DTO модели */
      'setRole' | 'address' | 'hasRoleChanges' | 'resetRole' | 'roleWasChangedInModal' | 'setRoleWasChangedInModal'
    >,
  ) {
    super(props)
    Object.assign(this, props)
  }

  static create({ district, externalId, officeName, pickpointId, role }: UserPvzRolesDTO) {
    return new EmployeeRole({ id: pickpointId, cachedRole: role, district, externalId, officeName, role })
  }

  @computed
  get address() {
    return [!this.district || this.district.trim?.().length === 0 ? '' : `${this.district},`, this.officeName].join(' ')
  }

  @computed
  get hasRoleChanges() {
    return this.role === this.cachedRole
  }

  @action
  setRole = (value: USER_PERMISSION) => {
    this.role = value
  }

  @action
  setRoleWasChangedInModal = (value: boolean) => {
    this.roleWasChangedInModal = value
  }

  @action
  resetRole = () => {
    this.role = this.cachedRole
  }
}
